import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { Tag } from '@zola/zola-ui';

import './PrintChecklistTaskItem.less';

const PrintChecklistTaskItem = props => {
  const { title, checklistTemplateName, isComplete, dueAt } = props;
  const formattedDueDate = dueAt && moment.utc(dueAt).format('LL');
  return (
    <div
      className={classNames('print-checklist-task-item', {
        'checklist-task-item--is_complete': isComplete,
      })}
    >
      <div className="print-task-item__left">
        <span className="checkbox-icon-wrapper" />
        <span className="print-task-item__title print-task-item__strike">{title}</span>
        {checklistTemplateName && (
          <Tag className="print-task-item__tradition" type="light-navy">
            {checklistTemplateName}
          </Tag>
        )}
      </div>
      <span className="print-task-item__due-date">Due {formattedDueDate}</span>
    </div>
  );
};

PrintChecklistTaskItem.propTypes = {
  title: PropTypes.string,
  checklistTemplateName: PropTypes.string,
  isComplete: PropTypes.bool,
  dueAt: PropTypes.string,
};

PrintChecklistTaskItem.defaultProps = {};

export default PrintChecklistTaskItem;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistTaskItem/PrintChecklistTaskItem.jsx